'use strict';

var Sugar = require('sugar-core');

require('./build/buildClassCheckMethodsCall');

module.exports = Sugar.Object.isNumber;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/isNumber.js
// module id = 815
// module chunks = 0